import { v4 as generateUuid } from 'uuid';

const generateUnique = (): string => `x${generateUuid().replace(/[^\d\w]/gm, '')}`;

export { generateUnique };

